/**
 * @generated SignedSource<<b7f033cb8a232093772ca25a4c359886>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteExpenseNatureInputObject = {
  expenseNatureId: string;
};
export type naturePivotPage_DeleteMutation$variables = {
  input: DeleteExpenseNatureInputObject;
};
export type naturePivotPage_DeleteMutation$data = {
  readonly deleteExpenseNature: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly expenseNature: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type naturePivotPage_DeleteMutation = {
  response: naturePivotPage_DeleteMutation$data;
  variables: naturePivotPage_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "naturePivotPage_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteExpenseNatureMutationPayload",
        "kind": "LinkedField",
        "name": "deleteExpenseNature",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "naturePivotPage_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteExpenseNatureMutationPayload",
        "kind": "LinkedField",
        "name": "deleteExpenseNature",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "93827c6ffc67dd7b9f8e724409550956",
    "id": null,
    "metadata": {},
    "name": "naturePivotPage_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation naturePivotPage_DeleteMutation(\n  $input: DeleteExpenseNatureInputObject!\n) {\n  deleteExpenseNature(input: $input) {\n    expenseNature {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce559edfbba25266a1c65372a06f7c40";

export default node;
